const animationEnterHero = () => {
	const header = document.querySelector('.header-hero');
	const hero = document.querySelector('.featured-hero img');
	const title = document.querySelectorAll('.title-effect > *');

	if (header) {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: header,
				//markers: true,
				once: true,
			},
			defaults: {
				duration: 1,
				ease: 'power2.inOut',
			},
		});

		tl.to(header, { duration: 0.5, autoAlpha: 1 });

		if (hero) {
			tl.from(
				hero,
				{
					duration: 1.5,
					scale: 1.05,
					ease: 'expoScale( 1.05, 1 )',
				},
				'<25%'
			);
		}

		if (title.length) {
			tl.from(
				title,
				{
					y: +100,
					autoAlpha: 0,
					stagger: 0.25,
				},
				'<25%'
			);
		}

		return tl;
	}
};

export default animationEnterHero;
